import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';
import { BlueLink } from 'components/common/link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  line-height: 3.5rem;
`;

const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 16px;
  text-align: center;
  white-space: break-spaces;
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratLight};
  font-size: 17px;
`;

export const SuspendedErrorModal = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  return (
    <Container>
      <SecondText>{TRANSLATION_TEXT.your_account_has_been_suspended}</SecondText>
      <SecondText>
        {`${TRANSLATION_TEXT.please}`}
        <StyledLink to={'https://www.rapnet.com/contact/support/'} external newTab>
          {TRANSLATION_TEXT.contact_us_lower}
        </StyledLink>
        {` ${TRANSLATION_TEXT.if_you_require_further_support} `}
      </SecondText>
      <SecondText>
        {TRANSLATION_TEXT.we_looking_forward_to_resolving_and_to_assisting_you}.
      </SecondText>
    </Container>
  );
};
export default SuspendedErrorModal;
